import {
  grid,
  maxBreakpoints,
  minBreakpoints,
  primarySemiBoldFont,
  theme,
} from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem, smallElevation } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { commonHeading } from './common.styles';

const { spacing } = theme;
const PANEL_OFFSET = spacing.lg;

export const partner = css`
  ${grid};
  grid-auto-rows: min-content;
  grid-column: auto / span 12;
  transform: translateY(-${pxToRem(PANEL_OFFSET)});
  border-bottom: 1px solid var(--neutral-black-30);
  padding-bottom: ${spacing.xxl}px;

  &:last-child {
    border: none;
    padding: 0;
  }

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-column: auto / span 6;
      display: flex;
      flex-direction: column;
      border: none;
      padding: 0;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      grid-row-gap: ${pxToRem(spacing.xxl)};
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.XL },
    css`
      display: grid;
    `,
  )}
`;

export const partnerImageContainer = css`
  grid-column: 1 / span 12;
  ${grid};

  ${mediaQuery(
    { min: minBreakpoints.XL },
    css`
      grid-column: 1 / span 6;
    `,
  )}
`;

export const partnerCopyContainer = css`
  ${grid};
  grid-column: 1 / span 12;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      flex: 1;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.XL },
    css`
      margin-top: ${spacing.xl + PANEL_OFFSET}px;
      grid-column: auto / span 6;
    `,
  )}
`;

export const partnerCopyContent = css`
  grid-column: 1 / span 12;

  ${mediaQuery(
    { min: minBreakpoints.M, max: maxBreakpoints.L },
    css`
      grid-column: 1 / span 10;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.XL },
    css`
      padding-right: ${spacing.xl}px;
    `,
  )}
`;

export const partnerHeading = css`
  ${commonHeading}
  margin: 0 0 ${spacing.xl}px 0;
`;

export const partnerCopy = css`
  ${theme.responsiveText.BODY.SM}
  margin: 0 0 ${spacing.xl}px 0;
`;

export const partnerCta = css`
  ${primarySemiBoldFont};
  ${theme.responsiveText.BODY.SM};
  color: var(--neutral-black-base);
`;

export const partnerImage = css`
  display: block;
  width: 100%;
  height: auto;
  border-radius: ${pxToRem(10)};
  overflow: hidden;
  ${smallElevation};

  grid-column: 1 / span 9;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-column: 1 / span 8;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      grid-column: 1 / span 6;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.XL },
    css`
      grid-column: 1 / span 12;
    `,
  )}
`;

export const productsContainer = css`
  grid-column: 1 / span 12;
  ${grid};
`;

export const product = css`
  grid-column: auto / span 6;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      &:first-child {
        grid-column: 1 / span 5;
      }

      &:last-child {
        grid-column: auto / span 5;
      }
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.XL },
    css`
      &:first-child {
        grid-column: 3 / span 4;
      }

      &:last-child {
        grid-column: auto / span 4;
      }
    `,
  )}
`;
